import { useState } from "react";
import {
  Phone,
  Mail,
  Facebook,
  Twitter,
  Instagram,
  Linkedin,
  Menu,
  X,
  FileText,
  ShieldCheck,
  Award,
  Calculator,
  Users,
  ChevronDown,
  ChevronUp,
} from "lucide-react";
import Logo from "../assets/img/gha.png";

const iconMap = { FileText, ShieldCheck, Award, Calculator, Users };

const megaMenuCategories = [
  {
    name: "Registrations",
    icon: "FileText",
    items: [
      { title: "Private Limited Company", href: "#" },
      { title: "Limited Liability Partnership", href: "#" },
      { title: "One Person Company", href: "#" },
      { title: "Partnership Firm", href: "#" },
      { title: "Sole Proprietorship", href: "#" },
      { title: "Section 8 Company", href: "#" },
      { title: "Nidhi Company", href: "#" },
      { title: "Producer Company", href: "#" },
      { title: "MSME Registration", href: "#" },
      { title: "FSSAI Registration", href: "#" },
      { title: "Import Export Code", href: "#" },
      { title: "Digital Signature Certificate", href: "#" },
    ],
  },
  {
    name: "Compliance",
    icon: "ShieldCheck",
    items: [
      { title: "Annual Filing", href: "#" },
      { title: "GST Filing", href: "#" },
      { title: "ROC Compliance", href: "#" },
      { title: "Payroll Compliance", href: "#" },
      { title: "Secretarial Audit", href: "#" },
      { title: "Due Diligence", href: "#" },
      { title: "DIR-3 KYC", href: "#" },
      { title: "Company Annual Return", href: "#" },
      { title: "LLP Annual Filing", href: "#" },
      { title: "Change in Directors", href: "#" },
      { title: "Change in Registered Office", href: "#" },
      { title: "Increase Authorized Capital", href: "#" },
    ],
  },
  {
    name: "IPR",
    icon: "Award",
    items: [
      { title: "Trademark Registration", href: "#" },
      { title: "Trademark Objection", href: "#" },
      { title: "Trademark Opposition", href: "#" },
      { title: "Copyright Registration", href: "#" },
      { title: "Patent Registration", href: "#" },
      { title: "Design Registration", href: "#" },
      { title: "Patent Search", href: "#" },
      { title: "Trademark Renewal", href: "#" },
      { title: "Trademark Assignment", href: "#" },
    ],
  },
  {
    name: "Taxation",
    icon: "Calculator",
    items: [
      { title: "Income Tax Return Filing", href: "#" },
      { title: "GST Registration", href: "#" },
      { title: "GST Return Filing", href: "#" },
      { title: "Tax Audit", href: "#" },
      { title: "TDS Return Filing", href: "#" },
      { title: "Professional Tax Registration", href: "#" },
      { title: "Tax Planning", href: "#" },
      { title: "Advance Tax Payment", href: "#" },
      { title: "Tax Notice Reply", href: "#" },
    ],
  },
  {
    name: "Consultation",
    icon: "Users",
    items: [
      { title: "Legal Consultation", href: "#" },
      { title: "Business Consultation", href: "#" },
      { title: "Tax Consultation", href: "#" },
      { title: "Startup Consultation", href: "#" },
      { title: "Compliance Consultation", href: "#" },
      { title: "HR Consultation", href: "#" },
    ],
  },
];

const navItems = [
  { label: "Home", href: "#" },
  { label: "Our Services", href: "#", hasMegaMenu: true },
  { label: "Blog", href: "#" },
  { label: "Contact Us", href: "#" },
  { label: "About Us", href: "#" },
];

const ACCENT = "#2563eb";
const ACCENT_HOVER_BG = "rgba(37,99,235,0.06)";
const CTA_COLOR = "#2563eb";
const CTA_HOVER = "#1d4ed8";

// ─── Desktop Mega Menu (hover-based) ────────────────────────────────────────
const MegaMenu = () => {
  const [activeCategory, setActiveCategory] = useState(0);
  return (
    <div
      style={{
        position: "absolute",
        top: "100%",
        left: "50%", transform: "translateX(-50%)",
        width: 820,
        borderRadius: 14,
        boxShadow: "0 20px 60px -12px rgba(0,0,0,0.22)",
        overflow: "hidden",
        zIndex: 50,
        border: "1px solid rgba(0,0,0,0.08)",
        display: "flex",
        background: "#fff",
        animation: "fadeSlideDown 0.18s ease",
      }}
    >
      {/* Left sidebar */}
      <div
        style={{
          width: 220,
          background:
            "linear-gradient(160deg, #1e3a8a 0%, #1e40af 40%, #2563eb 100%)",
          padding: "8px 0",
          maxHeight: 420,
          overflowY: "auto",
        }}
      >
        {megaMenuCategories.map((cat, i) => {
          const Icon = iconMap[cat.icon];
          return (
            <button
              key={cat.name}
              onMouseEnter={() => setActiveCategory(i)}
              style={{
                width: "100%",
                padding: "12px 24px",
                textAlign: "left",
                background:
                  activeCategory === i
                    ? "rgba(255,255,255,0.18)"
                    : "transparent",
                color: activeCategory === i ? "#fff" : "rgba(255,255,255,0.72)",
                border: "none",
                cursor: "pointer",
                fontSize: 14,
                fontWeight: 500,
                display: "flex",
                alignItems: "center",
                gap: 10,
                transition: "all 0.15s ease",
                borderLeft:
                  activeCategory === i
                    ? "3px solid #93c5fd"
                    : "3px solid transparent",
              }}
            >
              {Icon && <Icon size={15} />}
              {cat.name}
            </button>
          );
        })}
      </div>

      {/* Right panel */}
      <div
        style={{
          flex: 1,
          padding: "24px 28px",
          maxHeight: 420,
          overflowY: "auto",
          background: "#fff",
        }}
      >
        <h3
          style={{
            fontSize: 11,
            fontWeight: 700,
            color: ACCENT,
            letterSpacing: "0.15em",
            textTransform: "uppercase",
            marginBottom: 16,
            paddingBottom: 10,
            borderBottom: "2px solid rgba(37,99,235,0.15)",
          }}
        >
          {megaMenuCategories[activeCategory].name}
        </h3>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            columnGap: 32,
            rowGap: 0,
          }}
        >
          {megaMenuCategories[activeCategory].items.map((item) => (
            <a
              key={item.title}
              href={item.href}
              style={{
                fontSize: 13.5,
                color: "#555",
                textDecoration: "none",
                padding: "8px 0",
                display: "block",
                borderBottom: "1px solid #f3f4f6",
                transition: "all 0.15s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.color = ACCENT;
                e.currentTarget.style.paddingLeft = "6px";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = "#555";
                e.currentTarget.style.paddingLeft = "0px";
              }}
            >
              {item.title}
            </a>
          ))}
        </div>
      </div>

      <style>{`
        @keyframes fadeSlideDown {
          from { opacity: 0; transform: translateY(-6px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
};

// ─── Mobile Services Accordion ──────────────────────────────────────────────
const MobileServicesAccordion = () => {
  const [openCategory, setOpenCategory] = useState(null);

  return (
    <div style={{ borderTop: "1px solid #e5e7eb", marginTop: 4 }}>
      {megaMenuCategories.map((cat, i) => {
        const Icon = iconMap[cat.icon];
        const isOpen = openCategory === i;
        return (
          <div key={cat.name}>
            <button
              onClick={() => setOpenCategory(isOpen ? null : i)}
              style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "11px 16px",
                background: isOpen ? "rgba(37,99,235,0.05)" : "transparent",
                border: "none",
                borderBottom: "1px solid #f3f4f6",
                cursor: "pointer",
                fontSize: 13.5,
                fontWeight: 500,
                color: isOpen ? ACCENT : "#444",
              }}
            >
              <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
                {Icon && <Icon size={14} color={isOpen ? ACCENT : "#777"} />}
                {cat.name}
              </span>
              {isOpen ? (
                <ChevronUp size={14} color={ACCENT} />
              ) : (
                <ChevronDown size={14} color="#999" />
              )}
            </button>
            {isOpen && (
              <div
                style={{ background: "#f9fafb", padding: "8px 16px 12px 40px" }}
              >
                {cat.items.map((item) => (
                  <a
                    key={item.title}
                    href={item.href}
                    style={{
                      display: "block",
                      padding: "7px 0",
                      fontSize: 13,
                      color: "#555",
                      textDecoration: "none",
                      borderBottom: "1px solid #f0f0f0",
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.color = ACCENT)}
                    onMouseLeave={(e) => (e.currentTarget.style.color = "#555")}
                  >
                    {item.title}
                  </a>
                ))}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

// ─── Navbar ──────────────────────────────────────────────────────────────────
const Navbar = () => {
  const [megaMenuOpen, setMegaMenuOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [mobileServicesOpen, setMobileServicesOpen] = useState(false);

  return (
    <header
      style={{ width: "100%", fontFamily: "'Segoe UI', system-ui, sans-serif" }}
    >
      <style>{`
        .hamburger-btn { display: none !important; }
        .desktop-nav { display: flex !important; }
        @media (max-width: 1024px) {
          .hamburger-btn { display: flex !important; }
          .desktop-nav { display: none !important; }
          .cta-desktop { display: none !important; }
        }
      `}</style>

      {/* Top Bar */}
      <div style={{ background: "#f8f9fa", borderBottom: "1px solid #e5e7eb" }}>
        <div
          style={{
            maxWidth: 1200,
            margin: "0 auto",
            padding: "6px 24px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 20 }}>
            <a
              href="tel:+919473196196"
              style={{
                display: "flex",
                alignItems: "center",
                gap: 5,
                fontSize: 12,
                color: "#666",
                textDecoration: "none",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.color = ACCENT)}
              onMouseLeave={(e) => (e.currentTarget.style.color = "#666")}
            >
              <Phone size={12} /> +91 9473196196
            </a>
            <a
              href="mailto:info@gha.org.in"
              style={{
                display: "flex",
                alignItems: "center",
                gap: 5,
                fontSize: 12,
                color: "#666",
                textDecoration: "none",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.color = ACCENT)}
              onMouseLeave={(e) => (e.currentTarget.style.color = "#666")}
            >
              <Mail size={12} /> info@gha.org.in
            </a>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            {[Facebook, Twitter, Instagram, Linkedin].map((Icon, i) => (
              <a
                key={i}
                href="#"
                style={{ color: "#999", transition: "color 0.15s" }}
                onMouseEnter={(e) => (e.currentTarget.style.color = ACCENT)}
                onMouseLeave={(e) => (e.currentTarget.style.color = "#999")}
              >
                <Icon size={14} />
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* Main Nav */}
      <nav
        style={{
          background: "#fff",
          borderBottom: "1px solid #e5e7eb",
          boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
        }}
      >
        <div
          style={{
            maxWidth: 1200,
            margin: "0 auto",
            padding: "10px 24px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          {/* Logo */}
          <a
            href="#"
            style={{
              display: "flex",
              alignItems: "center",
              textDecoration: "none",
            }}
          >
            <img
              src={Logo}
              alt="GHA Logo"
              style={{
                height: 32,
                width: "auto",
                objectFit: "contain",
                display: "block",
              }}
              onError={(e) => {
                e.currentTarget.style.display = "none";
                e.currentTarget.nextSibling.style.display = "inline";
              }}
            />
            <span
              style={{
                display: "none",
                fontSize: 22,
                fontWeight: 800,
                color: "#111",
                letterSpacing: "-0.5px",
              }}
            >
              <span style={{ color: ACCENT }}>GHA</span>
            </span>
          </a>

          {/* Desktop Nav */}
          <ul
            className="desktop-nav"
            style={{
              alignItems: "center",
              gap: 2,
              listStyle: "none",
              margin: 0,
              padding: 0,
            }}
          >
            {navItems.map((item) => (
              <li
                key={item.label}
                style={{ position: "relative" }}
                onMouseEnter={() => item.hasMegaMenu && setMegaMenuOpen(true)}
                onMouseLeave={() => item.hasMegaMenu && setMegaMenuOpen(false)}
              >
                <a
                  href={item.href}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "8px 16px",
                    fontSize: 14,
                    fontWeight: 500,
                    color: "#444",
                    textDecoration: "none",
                    borderRadius: 8,
                    transition: "all 0.15s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.color = ACCENT;
                    e.currentTarget.style.background = ACCENT_HOVER_BG;
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.color = "#444";
                    e.currentTarget.style.background = "transparent";
                  }}
                >
                  {item.label}
                </a>
                {item.hasMegaMenu && megaMenuOpen && <MegaMenu />}
              </li>
            ))}
          </ul>

          {/* CTA (desktop) + Hamburger (mobile) */}
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <button
              className="cta-desktop"
              style={{
                background: CTA_COLOR,
                color: "#fff",
                border: "none",
                padding: "9px 22px",
                borderRadius: 8,
                fontWeight: 600,
                fontSize: 14,
                cursor: "pointer",
                transition: "background 0.15s",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.background = CTA_HOVER)
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.background = CTA_COLOR)
              }
            >
              Talk An Expert
            </button>

            {/* Hamburger — hidden on desktop via CSS class */}
            <button
              className="hamburger-btn"
              style={{
                background: "none",
                border: "none",
                cursor: "pointer",
                color: "#333",
                alignItems: "center",
                justifyContent: "center",
              }}
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div
            style={{
              background: "#fff",
              borderTop: "1px solid #e5e7eb",
              padding: "4px 0 16px",
            }}
          >
            {navItems.map((item) =>
              item.hasMegaMenu ? (
                <div key={item.label}>
                  <button
                    onClick={() => setMobileServicesOpen(!mobileServicesOpen)}
                    style={{
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "13px 24px",
                      background: "transparent",
                      border: "none",
                      borderBottom: "1px solid #f3f4f6",
                      cursor: "pointer",
                      fontSize: 14,
                      fontWeight: 500,
                      color: mobileServicesOpen ? ACCENT : "#444",
                    }}
                  >
                    {item.label}
                    {mobileServicesOpen ? (
                      <ChevronUp size={15} color={ACCENT} />
                    ) : (
                      <ChevronDown size={15} color="#999" />
                    )}
                  </button>
                  {mobileServicesOpen && <MobileServicesAccordion />}
                </div>
              ) : (
                <a
                  key={item.label}
                  href={item.href}
                  style={{
                    display: "block",
                    padding: "13px 24px",
                    fontSize: 14,
                    fontWeight: 500,
                    color: "#444",
                    textDecoration: "none",
                    borderBottom: "1px solid #f3f4f6",
                  }}
                >
                  {item.label}
                </a>
              ),
            )}
            <div style={{ padding: "12px 24px 0" }}>
              <button
                style={{
                  width: "100%",
                  background: CTA_COLOR,
                  color: "#fff",
                  border: "none",
                  padding: "11px",
                  borderRadius: 8,
                  fontWeight: 600,
                  fontSize: 14,
                  cursor: "pointer",
                }}
              >
                Talk An Expert
              </button>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Navbar;
